import React from "react";
import { Link } from "react-router-dom";
function AboutUsSection() {
  return (
    <div>
      <section className="about-us-section bg-dark">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-5">
            <div className="col-12 col-md-6">
              <div className="section-heading">
                <div className="sub-title text-white">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  About Us
                </div>
                <h2 className="mb-4 text-white">
                  We Help to Avoid & Solve Legal Problems
                </h2>
                <p className="mb-5 text-white">
                  Aliquam eu nunc imperdiet, volutpat mi vel, lobortis ligula.
                  pharetra dignissim lacus, faucibus volutpat lorem suscipit
                  nec. Nunc fringilla arcu eu massa ornare pharetra consectetur
                  molestie.
                </p>

                {/* Happy Counts */}
                <div className="happy-counts mb-5">
                  {/* Happy Clients */}
                  <div className="happy-count">
                    <h2 className="happy-count-number mb-0">
                      <span className="counter">1800</span>
                      <span>+</span>
                    </h2>
                    <span>Happy Clients</span>
                  </div>

                  <div className="count-border"></div>

                  {/* Finished Projects */}
                  <div className="happy-count">
                    <h2 className="happy-count-number mb-0">
                      <span className="counter">620</span>
                      <span>+</span>
                    </h2>
                    <span>Finished Projects</span>
                  </div>
                </div>

                <Link to="/aboutus" className="btn btn-primary">
                  <span>
                    Read More <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    Read More <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="row g-4">
                <div className="col-12">
                  <img
                    className="w-100"
                    src="assets/img/bg-img/36.jpg"
                    alt=""
                  />
                </div>

                <div className="col-6">
                  <img
                    className="w-100"
                    src="assets/img/bg-img/37.png"
                    alt=""
                  />
                </div>

                <div className="col-6">
                  <img
                    className="w-100"
                    src="assets/img/bg-img/38.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default AboutUsSection;
